<template>
  <div class="button-block" :class="alignmentClass">
    <a
      :href="computedHref"
      :target="linkTarget"
      :rel="linkRel"
      class="block-button"
      :class="[styleClass, sizeClass]"
    >
      {{ buttonText }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'ButtonBlock',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    buttonText() {
      return this.data.text || 'Button'
    },
    actionType() {
      return this.data.actionType || 'url'
    },
    computedHref() {
      switch (this.actionType) {
        case 'url': {
          // Same rule as the editor; also blocks javascript: links written directly to Firestore
          const url = this.data.url || ''
          return url.startsWith('/') || this.isValidHttpUrl(url) ? url : '#'
        }
        case 'email': {
          let href = `mailto:${this.data.email || ''}`
          if (this.data.emailSubject) {
            href += `?subject=${encodeURIComponent(this.data.emailSubject)}`
          }
          return href
        }
        case 'phone': {
          // Remove any non-digit characters except + for international format
          const cleanPhone = (this.data.phone || '').replace(/[^\d+]/g, '')
          return `tel:${cleanPhone}`
        }
        default:
          return '#'
      }
    },
    linkTarget() {
      // Only open in new tab for URL action type when specified
      if (this.actionType === 'url' && this.data.openInNewTab) {
        return '_blank'
      }
      return '_self'
    },
    linkRel() {
      // Add security attributes for external links
      if (this.linkTarget === '_blank') {
        return 'noopener noreferrer'
      }
      return null
    },
    alignment() {
      return this.data.alignment || 'center'
    },
    alignmentClass() {
      return `align-${this.alignment}`
    },
    buttonStyle() {
      return this.data.style || 'primary'
    },
    // Shared visitor button looks in buttons.css
    styleClass() {
      return `${this.buttonStyle}-button`
    },
    buttonSize() {
      return this.data.size || 'medium'
    },
    sizeClass() {
      return `size-${this.buttonSize}`
    }
  }
}
</script>

<style scoped>
.button-block {
  padding: 10px 0;
  width: 100%;

  &.align-left {
    text-align: left;
  }

  &.align-center {
    text-align: center;
  }

  &.align-right {
    text-align: right;
  }
}

.block-button {
  display: inline-block;
  margin: 0;
  text-decoration: none;
  cursor: pointer;

  /* Button Sizes */
  &.size-small {
    padding: 8px 16px;
    font-size: 13px;
  }

  &.size-medium {
    padding: 12px 24px;
    font-size: 15px;
  }

  &.size-large {
    padding: 16px 32px;
    font-size: 17px;
  }
}
</style>
